import { IAction, KEEP_THE_SAME, StateStatus } from '../../utils/common';
import * as Types from './types';

export interface IState {
  adminDashboardData: any;
  traderDashboardData: any;
}

const initialState: IState = {
  adminDashboardData: {
    status: null,
    data: null,
  },
  traderDashboardData: {
    status: null,
    data: null,
  },
};

const AdminDashboardReducer = (
  state: IState = initialState,
  action: IAction
): IState => {
  switch (action.type) {
    case Types.SET_ADMIN_DASHBOARD_DATA:
      return {
        ...state,
        adminDashboardData: {
          ...state.adminDashboardData,
          status: action.status,
          data:
            action.data === KEEP_THE_SAME
              ? state.adminDashboardData.data
              : action.data,
        },
      };
    case Types.SET_TRADER_DASHBOARD_DATA:
      return {
        ...state,
        traderDashboardData: {
          ...state.traderDashboardData,
          status: action.status,
          data:
            action.data === KEEP_THE_SAME
              ? state.traderDashboardData.data
              : action.data,
        },
      };
    default:
      return {
        ...state,
      };
  }
};

export default AdminDashboardReducer;
